"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useResponsive = void 0;
const useMediaQuery_1 = __importDefault(require("@mui/material/useMediaQuery"));
const json2mq_1 = __importDefault(require("json2mq"));
const responsive_1 = require("../../utils/responsive");
const isFunction_1 = require("../../utils/isFunction");
const useResponsive = ({ minWidth, maxWidth }) => {
    const minWidthBreakpoint = minWidth ? responsive_1.breakpoints[minWidth] : undefined;
    const maxWidthBreakpoint = maxWidth ? responsive_1.breakpoints[maxWidth] : undefined;
    const json2MqQuery = {};
    if (minWidthBreakpoint) {
        json2MqQuery.minWidth = minWidthBreakpoint;
    }
    if (maxWidthBreakpoint) {
        json2MqQuery.maxWidth = maxWidthBreakpoint;
    }
    const query = (0, json2mq_1.default)(json2MqQuery);
    const hasMatch = (0, useMediaQuery_1.default)(query);
    return hasMatch;
};
exports.useResponsive = useResponsive;
const Responsive = ({ minWidth, maxWidth, children }) => {
    const hasMatch = (0, exports.useResponsive)({ minWidth, maxWidth });
    if ((0, isFunction_1.isFunction)(children)) {
        return children(hasMatch);
    }
    return hasMatch ? children : null;
};
exports.default = Responsive;
//# sourceMappingURL=Responsive.js.map